<template lang="pug">
    .gzzoc-model-basic.y-clearfix
        logo
        UserNav
        .model-area(ref="model-area")
            .eyeball-area(v-if="status === 'not_start' || status === 'executing'")
                eyeball
            .circle(v-if="status === 'executing'")
                svg(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1000" height="1000" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1000 1000")
                    circle(cx="500" cy="500" r="250" stroke-opacity="1" style="stroke: #FFF; stroke-width: 2; fill: none;")
                        animate(values="250; 250; 500; 500" keyTimes="0; 0.01; 0.5; 1" dur="2s" repeatCount="indefinite" attributeName="r")
                        animate(values="0; 0; 1; 0; 0" keyTimes="0; 0; 0.01; 0.5; 1" dur="2s" repeatCount="indefinite" attributeName="stroke-opacity")
                    circle(cx="500" cy="500" r="250" style="stroke: #FFF; stroke-width: 2;  fill: none;")
                        animate(values="250; 250; 500; 500" keyTimes="0; 0.25; 0.75; 1" dur="2s" repeatCount="indefinite" attributeName="r")
                        animate(values="0; 0; 1; 0; 0" keyTimes="0; 0.24; 0.25; 0.75; 1" dur="2s" repeatCount="indefinite"  attributeName="stroke-opacity")
                    circle(cx="500" cy="500" r="250" style="stroke: #FFF; stroke-width: 2;  fill: none;")
                        animate(values="250; 250; 500; 500" keyTimes="0; 0.5; 0.99; 1" dur="2s" repeatCount="indefinite" attributeName="r")
                        animate(values="0; 0; 1; 0; 0" keyTimes="0; 0.49; 0.5; 0.99; 1" dur="2s" repeatCount="indefinite" attributeName="stroke-opacity")
        .basic-content-area
            .left-container.y-pull-left(ref="left-container")
                .head
                    .top
                        .return(@click="returnHome") {{$t('gzzoc.returnHome')}}
                        el-link.download-resource(v-if="downloadResource !== false" type="success" :underline="false" href='elderly-samples.rar' download='elderly-samples.rar') {{$t('gzzoc.downloadSample')}}
                    slot(name="left-title")
                .left-content
                    slot(name="left-content")
                    slot(name="left-footer")
            .right-container
                .right-content-wrapper(v-if="status === 'success'")
                    slot(name="right-header")
                        .header
                            // 占位，为了左右对称
                            .placeholder(:class="downloadPdfClass")
                            .title(:class="langClass") {{ getRightTitle }}
                            .download(v-if="downloadShow !== false", @click="downloadPDF" :class="downloadPdfClass")
                                .icon(:class="downloadPdfClass")
                                span.text {{downloadPdfText}}
                    slot(name="right-content")
                        div(style="display: block;height: 80%;visibility: none;")
                .right-content-wrapper(v-else-if="status === 'failed'")
                    .error-page
                        img.icon(src="~public/images/gzzoc/error.png")
                        .tip {{errorInfo || $t('gzzoc.modelError')}}
                // 占位用，使tips-area总是在底部
                .placeholder-area(v-else)
                .right-tips-area(ref="right-tips")
                    slot(name="right-tips")
</template>

<script>
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import Eyeball from '../components/eyeball';
import _ from 'lodash';
import ls from '@/utils/local-storage';
import { i18n } from "@/locale";

/**
 * 计算方法同 gzzoc/list
 */
function getModelAreaSize () {
    let top = 300;
    let clientHeight = window.document.body.clientHeight;
    let clientWidth = window.document.body.clientWidth;
    let height = Math.max(clientHeight - top, 600);
    let size = height * 2;
    let initialX = clientWidth / 2 - size / 2;
    // 420 left-container的宽度
    let afterX = (clientWidth - 420) / 2 + 420 - size / 2;
    let afterY = clientHeight / 2 - size / 2;
    return {
        size,
        initialY: top,
        initialX,
        afterX,
        afterY
    };
}

export default {
    props: ['showLeft', 'status', 'downloadResource', 'downloadShow', 'download', 'errorInfo','rightTitle', 'isCkd'],
    components: {
        Logo,
        UserNav,
        Eyeball
    },
    computed: {
        langClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        getRightTitle(){
            if(!!this.rightTitle){
                return this.rightTitle
            }
            return i18n.t('gzzoc.reportTitle')
        },
        downloadPdfClass () {
            return {
                ...this.langClass,
                'is-loading': this.download.loading
            };
        },
        downloadPdfText () {
            return this.download.loading ? i18n.t('gzzoc.prepareDownload') : i18n.t('gzzoc.downloadReport');
        }
    },
    mounted () {
        let style = getModelAreaSize();
        let modelArea = this.$refs['model-area'];
        modelArea.style.width = style.size + 'px';
        modelArea.style.height = style.size + 'px';
        modelArea.style.top = style.initialY + 'px';
        modelArea.style.left = style.initialX + 'px';
        modelArea.style.transition = 'left 1s linear, top 1s linear';
        // 加延迟，否则不会执行动画
        setTimeout(() => {
            modelArea.style.left = style.afterX + 'px';
            modelArea.style.top = style.afterY + 'px';
        }, 100);
        this.resizeThrottle = _.throttle(this.onWindowSizeChange.bind(this), 100);
        window.addEventListener('resize', this.resizeThrottle);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeThrottle);
    },
    methods: {
        returnHome () {
            this.$emit('stopHttp');
            this.$router.replace({
                path: '/model/list',
                query: {
                    entrance: this.isCkd ? 'CKD' : ''
                }
            });
        },
        downloadPDF () {
            this.$emit('download');
        },
        onWindowSizeChange () {
            let style = getModelAreaSize();
            let modelArea = this.$refs['model-area'];
            modelArea.style.left = style.afterX + 'px';
            modelArea.style.top = style.afterY + 'px';
        }
    },
    watch: {
        showLeft: {
            handler () {
                this.$nextTick(() => {
                    let leftContainer = this.$refs['left-container'];
                    let rightTips = this.$refs['right-tips'];
                    // 只有加载完数据之后，才会显示左边的form，并执行进入动画
                    if (this.showLeft) {
                        leftContainer.style.display = 'block';
                        leftContainer.style.animation = 'left-flip 0.5s linear';
                        rightTips.style.animation = 'right-tip-animate 0.5s linear';
                        rightTips.style.animationFillMode = 'forwards';
                    } else {
                        leftContainer.style.display = 'none';
                        leftContainer.style.animation = '';
                        rightTips.opacity = 0;
                        rightTips.style.animation = '';
                    }
                });
            },
            immediate: true
        }
    }
};
</script>
<style lang="sass">
    @keyframes left-flip
        0%
            transform: translateX(-100%)
        100%
            transform: translateX(0)
    @keyframes right-tip-animate
        0%
            opacity: 0
        100%
            opacity: 1
</style>
<style lang="sass" scoped>
    .gzzoc-model-basic
        color: #fff
        min-width: 1350px
        overflow-x: auto
        position: relative
    .basic-content-area
        position: relative
        padding: 80px 24px 20px 40px
    .left-container
        border-radius: 8px
        min-height: 350px
        background-image: linear-gradient(180deg, #F1F4FB 0%, #F6F7FA 98%)
        box-shadow: 0 8px 16px 0 rgba(27,25,80,0.10)
        position: fixed
        top: 80px
        left: 40px
        bottom: 20px
        .head
            padding: 16px 24px 24px
            border-radius: 16px 16px 0 0
            position: absolute
            top: 0
            left: 0
            width: 100%
            z-index: 1
            transition: height .2s ease-in
            overflow: hidden
            .top
                height: 20px
                line-height: 20px
                display: flex
                justify-content: space-between
                .return
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #333333
                    padding-left: 24px
                    background: url(~public/images/gzzoc/return.svg) no-repeat left 2px / 16px 16px
                    cursor: pointer
                .download-resource
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #20A0FE
                    padding-left: 24px
                    background: url(~public/images/gzzoc/download.svg) no-repeat left 2px / 16px 16px
    .left-content
        padding-top: 132px
        height: 100%
        display: flex
        flex-direction: column
    .model-area
        position: fixed
        &:after
            display: block
            position: absolute
            width: 100%
            border-top: 1px solid green
            top: 50%
        .eyeball-area
            width: 66.67%
            height: 0
            padding-top: 66.67%
            position: absolute
            left: 16.66%
            top: 16.66%
            animation: eyeball-animate 1s
            .eyeball-wrapper
                width: 100%
                position: absolute
                top: 0
                left: 0
        .circle
            position: absolute
            width: 100%
            height: 100%
            svg
                width: 100%
                height: 100%
    .right-container
        display: flex
        flex-direction: column
        justify-content: space-between
        align-items: stretch
        position: fixed
        top: 80px
        left: 470px
        bottom: 20px
        right: 24px
        overflow-y: auto
        .right-content-wrapper
            flex-grow: 0
            flex-shrink: 0
            overflow-y: auto
            background-image: linear-gradient(180deg, #F1F4FB 0%, #F6F7FA 98%)
            box-shadow: 0 8px 16px 0 rgba(27,25,80,0.10)
            border-radius: 8px
            padding: 0 24px 24px
            .header
                padding-top: 24px
                padding-bottom: 24px
                border-bottom: 1px solid #999
                position: relative
                display: flex
                flex-direction: row
                overflow-y: auto
                .title
                    flex: 1 1
                    font-family: PingFangSC-Semibold
                    font-size: 32px
                    line-height: 40px
                    color: #333333
                    text-align: center
                    white-space: pre-wrap
                    &.en
                        font-size: 26px
                .placeholder,
                .download
                    position: absolute
                    right: 24px
                    top: 24px
                    width: 180px
                    height: 40px
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #20A0FE
                    padding-left: 20px
                    line-height: 40px
                    cursor: pointer
                    display: flex
                    justify-content: flex-end
                    align-items: center
                    .icon
                        width: 16px
                        height: 16px
                        background: url(~public/images/gzzoc/download.svg) no-repeat top left / 16px 16px
                        &.is-loading
                            background-image: url(~public/images/gzzoc/loading.svg)
                    .text
                        margin-left: 8px
                .placeholder
                    background: none
                    &.is-loading
                        background: none
            .error-page
                display: flex
                flex-direction: column
                align-items: center
                margin-top: 138px
                margin-bottom: 138px
                .icon
                    width: 104px
                    height: 80px
                .tip
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #666666
                    text-align: center
        .right-tips-area
            opacity: 0
            flex-grow: 0
            flex-shrink: 0
    @media screen and (max-height: 600px)
        .basic-content-area
            display: flex
            position: relative
            .left-container
                flex: 0 0
                position: relative
                top: 0
                left: 0
                bottom: 0
                align-self: flex-start
            .right-container
                flex: 1 1
                min-width: 800px
                overflow-x: auto
                position: relative
                margin-left: 24px
                top: 0
                left: 0
                bottom: 0
                right: 0
</style>
